// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kV4Z","right":"styles_right__22Asv"};